import { createReducer, on } from '@ngrx/store';
import { HolidayTypeActions } from './holiday-type.actions';
import { Pagination } from '@core/interface/core';
import { HolidayType } from '@core/interface/holiday-type';

export const HolidayTypeFeatureKey = 'holiday-type';

export interface HolidayTypeState {
  holidayTypes: HolidayType[];
  isLoading: boolean;
  loadError?: any;
  addEditError?: any;
  pagination: Pagination;
}

export const initialState: HolidayTypeState = {
  holidayTypes: [],
  isLoading: true,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const HolidayTypeReducer = createReducer(
  initialState,
  on(HolidayTypeActions.loadHolidayType, (state) => ({ ...state })),
  on(
    HolidayTypeActions.loadHolidayTypeSuccess,
    (state, { data, pagination }) => ({
      ...state,
      pagination,
      holidayTypes: data,
      isLoading: false,
      isDeleted: false,
      loadError: null,
    })
  ),
  on(HolidayTypeActions.loadHolidayTypeFailure, (state, { error }) => {
    return { ...state, loadError: error, isLoading: false, isDeleted: false };
  }),
  on(HolidayTypeActions.addHolidayTypeSuccess, (state, { data }) => ({
    ...state,
    holidayTypes: [...state.holidayTypes, data],
    isDeleted: false,
    addEditError: null,
  })),
  on(HolidayTypeActions.addHolidayTypeFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(HolidayTypeActions.updateHolidayTypeSuccess, (state, { data }) => ({
    ...state,
    holidayTypes: state.holidayTypes.map((holiday) =>
      data.id == holiday.id ? data : holiday
    ),
    isDeleted: false,
    addEditError: null,
  })),
  on(HolidayTypeActions.updateHolidayTypeFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  }))
);
